import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";


// テーマ別販売カテゴリ一追加情報を格納する


@Module({
    name: "ThemeCategoryVariablesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ThemeCategoryVariablesStore extends VuexModule {

    // state
    private _apiResponse: CMS.ThemeCategoryVariable[] = [];
    private _variableByCategoryId: { [categoryId: number]: CMS.ThemeCategoryVariable } = {};

    private apiBackup: CMS.ThemeCategoryVariable[] = [];
    private edited: { [categoryId: number]: CMS.ThemeCategoryVariable } = {};
    private menuId: number = -1;  // 再取得時用に内部保持

    // getter
    get all() {
        return this._apiResponse || [];
    }

    get variableByCategoryId(): { [p: number]: CMS.ThemeCategoryVariable } {
        return this._variableByCategoryId || {};
    }

    get dirty(): boolean {
        return Object.keys(this.edited).length > 0;
    }

    @Action
    public async init(param: { themeId: number, menuId: number }) {
        this.setMenuId(param.menuId);
        const response: CMS.ThemeCategoryVariable[] = await CmsApiClient.getThemeCategoryVariables(param.themeId, param.menuId);
        this.refresh(response);
    }

    @Mutation
    private setMenuId(menuId: number) {
        this.menuId = menuId;
    }

    @Action
    private refresh(response: CMS.ThemeCategoryVariable[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setVariableByItemId(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._variableByCategoryId = {};
        this.edited = {};
    }

    @Mutation
    private setResponse(response: CMS.ThemeCategoryVariable[]) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    private setVariableByItemId(variable: CMS.ThemeCategoryVariable) {
        Vue.set(this._variableByCategoryId, variable.category_id, variable);
    }

    @Mutation
    public localAdd(themeCategoryVariable: CMS.ThemeCategoryVariable) {
        const categoryId: number = themeCategoryVariable.category_id;

        themeCategoryVariable.id = Util.getTempId(this.all as any);
        this._apiResponse.push(themeCategoryVariable);
        Vue.set(this._variableByCategoryId, categoryId, themeCategoryVariable);
        Vue.set(this.edited, categoryId, themeCategoryVariable);
    }

    @Mutation
    public localEdit(themeCategoryVariable: CMS.ThemeCategoryVariable) {
        const categoryId: number = themeCategoryVariable.category_id;

        this._apiResponse = this._apiResponse.map(v => (v.id == themeCategoryVariable.id) ? themeCategoryVariable : v);
        Vue.set(this._variableByCategoryId, categoryId, themeCategoryVariable);
        Vue.set(this.edited, categoryId, themeCategoryVariable);
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async applyEdit() {
        if (!this.dirty)
            return;

        let themeId!: number;
        for (const categoryId in this.edited) {
            await CmsApiClient.setThemeCategoryVariable(this.edited[categoryId]);
            themeId = this.edited[categoryId].theme_id;
        }

        this.init({themeId: themeId, menuId: this.menuId});
    }
}

export default getModule(ThemeCategoryVariablesStore);
